"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _arrayFrom = _interopRequireDefault(require("array-from"));

var _objectIs = _interopRequireDefault(require("object-is"));

require("react-dates/initialize");

var _stringPrototype = _interopRequireDefault(require("string.prototype.padstart"));

require("core-js/fn/object/keys");

var _reactDates = require("react-dates");

var _button = _interopRequireDefault(require("./button"));

var _icon = _interopRequireDefault(require("./icon"));

var _select = _interopRequireDefault(require("./select"));

require("../css/datepicker.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

if (!Array.from) Array.from = _arrayFrom.default;
if (!Object.is) Object.is = _objectIs.default;

_stringPrototype.default.shim();

var DatePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
      window.addEventListener('click', _this.handleWindowClick);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      window.removeEventListener('click', _this.handleWindowClick);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocusChange", function (_ref) {
      var focused = _ref.focused;

      _this.setState({
        focused: focused
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onRangeFocusChange", function (focusedInput) {
      _this.setState({
        focusedInput: !focusedInput ? 'startDate' : focusedInput
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
      switch (event.keyCode) {
        case 13:
          // ENTER
          _this.setState({
            focused: true
          });

          break;

        case 27:
          // ESC
          _this.setState({
            focused: false
          });

          event.preventDefault();
          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDownClear", function (event) {
      switch (event.keyCode) {
        case 32: // SPACE

        case 13:
          // ENTER
          event.stopPropagation();

          _this.handleClearClick();

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOnChange", function (value) {
      _this.setState({
        value: value
      }, function () {
        return _this.props.onChange(_this.state.value);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOnRangeChange", function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;

      _this.setState({
        startDate: startDate,
        endDate: endDate
      }, function () {
        return _this.props.onChange(_this.state.startDate, _this.state.endDate);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowClick", function (event) {
      if (!_this.state.focused) return;
      if (_this.node.contains(event.target)) return;

      _this.setState({
        focused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      if (_this.props.disabled) return;

      _this.setState(function (state) {
        return {
          focused: !state.focused
        };
      }, function () {
        _this.inputNode.blur();
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClearClick", function () {
      var onClear = _this.props.onClear;

      _this.setState({
        currentMonth: null,
        focused: false,
        focusedInput: 'startDate',
        endDate: null,
        startDate: null,
        value: null
      }, onClear());
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "todayHandleClick", function () {
      var today = (0, _moment.default)();

      _this.setState(function (state) {
        return {
          focused: !state.focused,
          value: today
        };
      }, function () {
        return _this.props.onChange(_this.state.value);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleNewCurrentMonth", function (currentMonth) {
      _this.setState({
        currentMonth: currentMonth
      });
    });

    _this.state = {
      value: props.value,
      localization: props.localization,
      error: props.error,
      focusedInput: 'startDate',
      startDate: props.startDate,
      endDate: props.endDate,
      currentMonth: (0, _moment.default)(props.value) || (0, _moment.default)()
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value,
        focused: nextProps.focused,
        localization: nextProps.localization,
        error: nextProps.error,
        startDate: nextProps.startDate,
        endDate: nextProps.endDate
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      _moment.default.locale(this.state.localization);

      var date = this.state.value ? (0, _moment.default)(this.state.value) : null;
      var startDate = this.state.startDate ? (0, _moment.default)(this.state.startDate) : null;
      var endDate = this.state.endDate ? (0, _moment.default)(this.state.endDate) : null;
      var focusedInput = this.state.focusedInput;
      var hasDatePicked = this.state.value || startDate;

      var _this$props = this.props,
          blockFutureDates = _this$props.blockFutureDates,
          blockPastDates = _this$props.blockPastDates,
          calendarOrientation = _this$props.calendarOrientation,
          className = _this$props.className,
          clearIcon = _this$props.clearIcon,
          disabled = _this$props.disabled,
          enableOutsideDays = _this$props.enableOutsideDays,
          propsEndDate = _this$props.endDate,
          error = _this$props.error,
          focused = _this$props.focused,
          format = _this$props.format,
          i18n = _this$props.i18n,
          localization = _this$props.localization,
          onChange = _this$props.onChange,
          onClear = _this$props.onClear,
          placeholder = _this$props.placeholder,
          range = _this$props.range,
          propsStartDate = _this$props.startDate,
          monthYearNavigation = _this$props.monthYearNavigation,
          value = _this$props.value,
          yearsRange = _this$props.yearsRange,
          otherProps = _objectWithoutProperties(_this$props, ["blockFutureDates", "blockPastDates", "calendarOrientation", "className", "clearIcon", "disabled", "enableOutsideDays", "endDate", "error", "focused", "format", "i18n", "localization", "onChange", "onClear", "placeholder", "range", "startDate", "monthYearNavigation", "value", "yearsRange"]);

      var classes = {
        'vn-datepicker__input': true,
        'vn-datepicker__input--two-buttons': clearIcon && hasDatePicked,
        'vn-datepicker__input--open': this.state.focused,
        'vn-datepicker__input--error': this.state.error
      };
      var divClasses = {
        'vn-datepicker': true,
        'vn-datepicker--error': this.state.error
      };

      if (className) {
        divClasses[className] = true;
      }

      var ulClasses = {
        'vn-datepicker__calendar': true,
        'vn-datepicker__calendar--left': calendarOrientation.includes('left'),
        'vn-datepicker__calendar--upwards': calendarOrientation.includes('up'),
        'vn-datepicker__calendar--range': range
      };
      var nextArrowClasses = {
        'vn-datepicker__arrow--next': !monthYearNavigation,
        'vn-datepicker__caption__arrow--next': monthYearNavigation
      };
      var prevArrowClasses = {
        'vn-datepicker__arrow--prev': !monthYearNavigation,
        'vn-datepicker__caption__arrow--prev': monthYearNavigation
      };

      var outSideRangeDates = function outSideRangeDates() {
        if (blockFutureDates) {
          return function (day) {
            return (0, _reactDates.isInclusivelyAfterDay)(day, (0, _moment.default)().add(1, 'day'));
          };
        }

        if (blockPastDates) {
          return function (day) {
            return (0, _reactDates.isInclusivelyBeforeDay)(day, (0, _moment.default)().subtract(1, 'day'));
          };
        }

        return undefined;
      };

      var monthsToHash = function monthsToHash() {
        var months = [];

        for (var i = 0; i <= 11; i += 1) {
          months.push({
            value: i,
            label: (0, _moment.default)().month(i).format('MMMM')
          });
        }

        return months;
      };

      var yearsToHash = function yearsToHash() {
        var years = [];

        for (var i = yearsRange.start; i <= yearsRange.end; i += 1) {
          years.push({
            value: i,
            label: i.toString()
          });
        }

        return years;
      };

      var captionNavigation = function captionNavigation(_ref3) {
        var month = _ref3.month,
            onMonthSelect = _ref3.onMonthSelect,
            onYearSelect = _ref3.onYearSelect;
        return _react.default.createElement("div", {
          className: "vn-datepicker__caption"
        }, _react.default.createElement(_select.default, {
          clearIcon: false,
          value: [month.month()],
          onChange: function onChange(option) {
            _this2.handleNewCurrentMonth(month.month(option.value));

            onMonthSelect(month, option.value);
          },
          options: monthsToHash(),
          visibleOptions: 5
        }), _react.default.createElement(_select.default, {
          clearIcon: false,
          value: [month.year()],
          onChange: function onChange(option) {
            _this2.handleNewCurrentMonth(month.year(option.value));

            onYearSelect(month, option.value);
          },
          options: yearsToHash(),
          visibleOptions: 5
        }));
      };

      var renderNavNextIcon = function renderNavNextIcon() {
        if (monthYearNavigation) {
          var lastMonth = (0, _moment.default)().year(yearsRange.end).month(11);

          if (lastMonth.isSame(_this2.state.currentMonth, 'month')) {
            return _react.default.createElement("div", null);
          }
        }

        return _react.default.createElement(_icon.default, {
          name: "chevron",
          className: (0, _classnames.default)(nextArrowClasses)
        });
      };

      var renderNavPrevIcon = function renderNavPrevIcon() {
        if (monthYearNavigation) {
          var firstMonth = (0, _moment.default)().year(yearsRange.start).month(0);

          if (firstMonth.isSame(_this2.state.currentMonth, 'month')) {
            return _react.default.createElement("div", null);
          }
        }

        return _react.default.createElement(_icon.default, {
          name: "chevron",
          className: (0, _classnames.default)(prevArrowClasses)
        });
      };

      var handleIconClick = function handleIconClick(newCurrentMonth) {
        _this2.handleNewCurrentMonth(newCurrentMonth);
      };

      var dateString;
      var today = [(0, _moment.default)()];
      var datePicker;

      if (range) {
        var startDateString = startDate ? (0, _moment.default)(startDate).format(format) : '';
        var endDateString = endDate ? " - ".concat((0, _moment.default)(endDate).format(format)) : '';
        dateString = startDateString + endDateString;
        datePicker = _react.default.createElement("ul", {
          className: (0, _classnames.default)(ulClasses)
        }, _react.default.createElement(_reactDates.DayPickerRangeController, _extends({}, otherProps, {
          numberOfMonths: 2,
          focusedInput: focusedInput,
          isDayHighlighted: function isDayHighlighted(day) {
            return today.some(function (day2) {
              return (0, _reactDates.isSameDay)(day, day2);
            });
          },
          isOutsideRange: outSideRangeDates(),
          onDatesChange: this.handleOnRangeChange,
          onFocusChange: this.onRangeFocusChange,
          enableOutsideDays: enableOutsideDays,
          minimumNights: 1,
          daySize: 24,
          navNext: _react.default.createElement(_icon.default, {
            name: "chevron",
            className: "vn-datepicker__arrow--next"
          }),
          navPrev: _react.default.createElement(_icon.default, {
            name: "chevron",
            className: "vn-datepicker__arrow--prev"
          }),
          hideKeyboardShortcutsPanel: true,
          startDate: startDate,
          endDate: endDate,
          transitionDuration: 0
        })));
      } else {
        dateString = date ? (0, _moment.default)(date).format(format) : '';
        datePicker = _react.default.createElement("ul", {
          className: (0, _classnames.default)(ulClasses)
        }, _react.default.createElement(_reactDates.DayPickerSingleDateController, _extends({}, otherProps, {
          date: date,
          numberOfMonths: 1,
          focused: true,
          isDayHighlighted: function isDayHighlighted(day) {
            return today.some(function (day2) {
              return (0, _reactDates.isSameDay)(day, day2);
            });
          },
          isOutsideRange: outSideRangeDates(),
          onDateChange: this.handleOnChange,
          onFocusChange: this.onFocusChange,
          onNextMonthClick: handleIconClick,
          onPrevMonthClick: handleIconClick,
          enableOutsideDays: enableOutsideDays,
          daySize: 24,
          navNext: renderNavNextIcon(),
          navPrev: renderNavPrevIcon(),
          hideKeyboardShortcutsPanel: true,
          renderMonthElement: monthYearNavigation ? captionNavigation : undefined,
          transitionDuration: 0
        })), _react.default.createElement(_button.default, {
          name: "button",
          className: "vn-datepicker__button",
          onClick: this.todayHandleClick,
          appearance: "secondary"
        }, i18n.today));
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(divClasses),
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement("input", _extends({}, otherProps, {
        "aria-label": "datepicker value",
        className: (0, _classnames.default)(classes),
        onClick: this.handleClick,
        onKeyDown: this.onKeyDown,
        value: dateString,
        placeholder: placeholder,
        readOnly: true,
        ref: function ref(node) {
          _this2.inputNode = node;
        },
        disabled: disabled
      })), !disabled && clearIcon && hasDatePicked && _react.default.createElement("button", {
        "aria-label": i18n.clear,
        className: "vn-datepicker__clear-button",
        type: "button",
        tabIndex: 0,
        onClick: this.handleClearClick,
        onKeyDown: this.handleKeyDownClear
      }, _react.default.createElement(_icon.default, {
        name: "close"
      })), _react.default.createElement(_icon.default, {
        name: "calendar",
        className: "vn-datepicker__calendar-icon",
        disabled: disabled,
        onClick: this.handleClick
      }), this.state.focused && _react.default.createElement("div", null, datePicker));
    }
  }]);

  return DatePicker;
}(_react.default.Component);

DatePicker.propTypes = {
  blockFutureDates: _propTypes.default.bool,
  blockPastDates: _propTypes.default.bool,
  calendarOrientation: _propTypes.default.arrayOf(_propTypes.default.string),
  className: _propTypes.default.string,
  clearIcon: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  enableOutsideDays: _propTypes.default.bool,
  endDate: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]),
  error: _propTypes.default.bool,
  focused: _propTypes.default.bool,
  format: _propTypes.default.string,
  i18n: _propTypes.default.shape({
    today: _propTypes.default.string.isRequired,
    clear: _propTypes.default.string.isRequired
  }),
  localization: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onClear: _propTypes.default.func,
  range: _propTypes.default.bool,
  monthYearNavigation: _propTypes.default.bool,
  startDate: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]),
  value: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]),
  yearsRange: _propTypes.default.shape({
    start: _propTypes.default.number.isRequired,
    end: _propTypes.default.number.isRequired
  })
};
DatePicker.defaultProps = {
  blockFutureDates: false,
  blockPastDates: false,
  calendarOrientation: [],
  className: undefined,
  clearIcon: true,
  disabled: false,
  enableOutsideDays: false,
  endDate: null,
  error: false,
  focused: false,
  format: 'LL',
  i18n: {
    today: 'Today',
    clear: 'Clear'
  },
  localization: 'en',
  placeholder: '',
  onChange: function onChange() {},
  onClear: function onClear() {},
  range: false,
  monthYearNavigation: false,
  startDate: null,
  value: null,
  yearsRange: {
    start: (0, _moment.default)().year() - 20,
    end: (0, _moment.default)().year() + 20
  }
};
DatePicker.displayName = 'DatePicker';
var _default = DatePicker;
exports.default = _default;